"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import type { ClassNameProp } from "../../props";
import { Card, type CardProps } from "../Card/Card";
import { Text } from "../Text/Text";
import { Graph, type GraphProps } from "../Graph/Graph";
import { cardStyle, graphStyle } from "./GraphCard.css";
import { Flex } from "../Flex/Flex";

export type GraphCardProps = HTMLAttributes<
  HTMLDivElement | HTMLButtonElement
> &
  ClassNameProp & {
    title?: string;
    data: GraphProps["data"];
    valueFormat?: GraphProps["valueFormat"];
    type?: GraphProps["type"];
    entries?: GraphProps["entries"];
    columns?: CardProps["columns"];
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement | HTMLButtonElement>;
  };

/**
 * A card component that displays a graph.
 */
export const GraphCard: FC<GraphCardProps> = ({
  title,
  className,
  data,
  valueFormat,
  type,
  entries,
  ref,
  ...props
}) => (
  <Card
    ref={ref as Ref<HTMLDivElement>}
    className={mergeClasses(cardStyle, className)}
    variant="primary"
    border="default"
    gap="m"
    {...props}
  >
    <Text variant="bodyL">{title}</Text>
    <Flex justify="center" align="center" direction="column" gap="m">
      <Graph
        className={graphStyle}
        data={data}
        valueFormat={valueFormat}
        type={type}
        entries={entries}
      />
    </Flex>
  </Card>
);
